import { Rate as AntRate, type RateProps } from 'antd'
import type { ComponentRef, Ref } from 'react'

export type { RateProps }

// antd 5 Rate had no sizes, antd 6 takes `large` from our `componentSize`
export const Rate = ({
  size = 'middle',
  ref,
  ...props
}: RateProps & { ref?: Ref<ComponentRef<typeof AntRate>> }) => (
  <AntRate {...props} ref={ref} size={size} />
)
